import { render, staticRenderFns } from "./ControlAddedLessons.vue?vue&type=template&id=6d4424ac&scoped=true&"
import script from "./ControlAddedLessons.vue?vue&type=script&lang=js&"
export * from "./ControlAddedLessons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4424ac",
  null
  
)

export default component.exports